export default __webpack_public_path__ + "static/media/rolling.025c78f3.gif";